import EventEmitter from '@/helpers/EventEmitter'
import firebase from 'firebase/app';
import database from 'firebase/database';
import * as firebaseui from 'firebaseui'

const Events = {
    AUTH_STATE_CHANGE: 'AUTH_STATE_CHANGE',
    ACCOUNT_STATE_CHANGE: 'ACCOUNT_STATE_CHANGE',
    USER_SIGN_IN: 'USER_SIGN_IN',
    USER_SIGN_OUT: 'USER_SIGN_OUT'
}

let defaultConfig = {

    apiKey: "",
    authDomain: "",
    databaseURL: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",

    CLIENT_ID: '',
    
    signInOpts: {
        guest: false,
        email: false,
        phone: false,
        google: false,
        facebook: false,
        twitter: false,
        github: false  
    }
}


class FirebaseService {
    
    constructor(config) {

        Object.assign(this, EventEmitter, {});

        this.config = Object.assign(defaultConfig, config)
        this.setupOptions();
        firebase.initializeApp(this.config);

        // Initialize the FirebaseUI Widget using Firebase.
        this.ui = new firebaseui.auth.AuthUI(firebase.auth());
        // Disable auto-sign in.
        this.ui.disableAutoSignIn();

        // Listen to change in auth state so it displays the correct UI for when
        // the user is signed in or not.
        firebase.auth().onAuthStateChanged(this.onAuthStateChange); 
    } 

    // snapshot(){
    //     var userId = firebase.auth().currentUser.uid;
    //     return firebase.database()
    //     .ref('/users/' + userId)
    //     .once('value')
    //     .then(snapshot => { 
    //         let entry = snapshot.val()
    //         if( entry && entry.accountType){
    //             console.log(entry);
    //             this.emit(Events.ACCOUNT_STATE_CHANGE, entry.accountType)
    //         }
    //     })
    //     .catch(error => {
    //         console.log(error);
    //     });
    // }

    setupOptions() {

        this.signInOptions = [];

        // google
        if(this.config.signInOpts.google){
            this.signInOptions.push({
                provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                // Required to enable this provider in One-Tap Sign-up.
                authMethod: 'https://accounts.google.com',
                // Required to enable ID token credentials for this provider.
                clientId: this.config.CLIENT_ID
            })
        }

        // facebook
        if(this.config.signInOpts.facebook){
            this.signInOptions.push({
                provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
                scopes :[
                  'public_profile',
                  'email',
                  'user_likes',
                  'user_friends'
                ]
          })
        }

        // twitter
        if(this.config.signInOpts.twitter){
            this.signInOptions.push(firebase.auth.TwitterAuthProvider.PROVIDER_ID)
        }

        // github
        if(this.config.signInOpts.github){
            this.signInOptions.push(firebase.auth.GithubAuthProvider.PROVIDER_ID)
        }

        // email
        if(this.config.signInOpts.email){
            this.signInOptions.push({
                provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
                // Whether the display name should be displayed in Sign Up page.
                requireDisplayName: true
            })
        }

        // phone
        if(this.config.signInOpts.phone){
            this.signInOptions.push({
                provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
                recaptchaParameters: {
                  size: this.getRecaptchaMode()
                }
            })
        }

        // guest
        if(this.config.signInOpts.guest){
            this.signInOptions.push(firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID)
        } 
    }

    onAuthStateChange = (user) => { 
        user ? this.handleSignedInUser(user) : this.handleSignedOutUser();
    }

    signOut() {
        firebase.auth().signOut();
    }


    /**
     * FirebaseUI initialization to be used in a Single Page application context.
     */

    /**
     * @return {!Object} The FirebaseUI config.
     */
    getUiConfig = () => {
      return {
        'callbacks': {
          // Called when the user has been successfully signed in.
          'signInSuccessWithAuthResult': (authResult, redirectUrl) => {
            if (authResult.user) {
              this.handleSignedInUser(authResult.user);
            }
            // if (authResult.additionalUserInfo) {
            //   document.getElementById('is-new-user').textContent = authResult.additionalUserInfo.isNewUser ? 'New User' : 'Existing User';
            // }
            // Do not redirect.
            return false;
          }
        },
        // Opens IDP Providers sign-in flow in a popup.
        'signInFlow': 'popup',
        'signInOptions': this.signInOptions,
        // Terms of service url.
        'tosUrl': 'https://www.google.com',
        // Privacy policy url.
        'privacyPolicyUrl': 'https://www.google.com'
        // 'credentialHelper': this.config.CLIENT_ID && this.config.CLIENT_ID != 'YOUR_OAUTH_CLIENT_ID' ?
        //     firebaseui.auth.CredentialHelper.GOOGLE_YOLO :
        //     firebaseui.auth.CredentialHelper.ACCOUNT_CHOOSER_COM
      };
    } 
    

    getRecaptchaMode() {
      // Quick way of checking query params in the fragment. If we add more config
      // we might want to actually parse the fragment as a query string.
      return location.hash.indexOf('recaptcha=invisible') !== -1 ? 'invisible' : 'normal';
    }


    /**
     * @return {string} The URL of the FirebaseUI standalone widget.
     */
    getWidgetUrl() {
      return '/widget#recaptcha=' + this.getRecaptchaMode();
    }


    /**
     * Redirects to the FirebaseUI widget.
     */
    signInWithRedirect() {
      window.location.assign(this.getWidgetUrl());
    };


    /**
     * Open a popup with the FirebaseUI widget.
     */
    signInWithPopup() {
      window.open(this.getWidgetUrl(), 'Sign In', 'width=985,height=735');
    };


    /**
     * Displays the UI for a signed in user.
     * @param {!firebase.User} user
     */
    handleSignedInUser = (user) => {
        this.emit(Events.USER_SIGN_IN, user);  
    };


    /**
     * Displays the UI for a signed out user.
     */
    handleSignedOutUser = () => { 
        this.emit(Events.USER_SIGN_OUT, this.getUiConfig()); 
    };

    /**
     * Deletes the user's account.
     */ 
    deleteAccount() {
      firebase
      .auth()
      .currentUser
      .delete()
      .catch((error) => {
        if (error.code == 'auth/requires-recent-login') {
          // The user's credential is too old. She needs to sign in again.
          firebase
          .auth()
          .signOut()
          .then(() => {
            // The timeout allows the message to be displayed after the UI has
            // changed to the signed out state.
            setTimeout(() => {
              alert('Please sign in again to delete your account.');
            }, 1);
          });
        }
      });
    };


    /**
     * Handles when the user changes the reCAPTCHA config.
     */
    handleRecaptchaConfigChange() {
        var newRecaptchaValue = document.querySelector( 'input[name="recaptcha"]:checked').value;
        location.replace(location.pathname + '#recaptcha=' + newRecaptchaValue);

        // // Reset the inline widget so the config changes are reflected.
        // this.ui.reset();
        // this.ui.start('#firebaseui-container', this.getUiConfig());
    }

    writeUserData(value) { 
        var userId = firebase.auth().currentUser.uid; 
        var ref = firebase.database().ref('/users/' + userId);
        ref.set({
            accountType: value 
        });
    }
}

let service = FirebaseService
service.Events = Events
export default service